import React from 'react';
import { Users, Award, Truck, Clock, Wrench, Shield } from 'lucide-react';
export function About() {
  return <div className="bg-[#f8f9fa] min-h-screen" data-id="element-237">
      {/* Hero */}
      <div className="bg-[#0056b3] text-white py-16" data-id="element-238">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-239">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-240">
            Sobre Materiales Brasil, C.A.
          </h1>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto" data-id="element-241">
            Tu ferretería de confianza en Caracas. Más de una década sirviendo a
            constructores, profesionales y hogares venezolanos.
          </p>
        </div>
      </div>

      {/* Stats */}
      <div className="max-w-7xl mx-auto px-4 -mt-8 relative z-10" data-id="element-242">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-white rounded-lg shadow-sm border border-gray-100 p-6" data-id="element-243">
          <div className="text-center" data-id="element-244">
            <div className="text-2xl md:text-3xl font-bold text-[#0056b3] mb-1" data-id="element-245">
              10+
            </div>
            <div className="text-xs md:text-sm text-gray-500" data-id="element-246">
              Años de Experiencia
            </div>
          </div>
          <div className="text-center" data-id="element-247">
            <div className="text-2xl md:text-3xl font-bold text-[#0056b3] mb-1" data-id="element-248">
              5000+
            </div>
            <div className="text-xs md:text-sm text-gray-500" data-id="element-249">
              Clientes Satisfechos
            </div>
          </div>
          <div className="text-center" data-id="element-250">
            <div className="text-2xl md:text-3xl font-bold text-[#0056b3] mb-1" data-id="element-251">
              2000+
            </div>
            <div className="text-xs md:text-sm text-gray-500" data-id="element-252">
              Productos en Stock
            </div>
          </div>
          <div className="text-center" data-id="element-253">
            <div className="text-2xl md:text-3xl font-bold text-[#0056b3] mb-1" data-id="element-254">
              6 días
            </div>
            <div className="text-xs md:text-sm text-gray-500" data-id="element-255">
              Atención Semanal
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-16" data-id="element-256">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-257">
          <div data-id="element-258">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-259">
              Nuestra Historia
            </h2>
            <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-260">
              Materiales Brasil, C.A. nació en Caracas con una visión clara:
              ofrecer productos de ferretería de la más alta calidad a precios
              justos. Desde nuestros inicios, nos hemos comprometido con la
              excelencia en el servicio y la satisfacción de nuestros clientes.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-261">
              Hoy somos distribuidores autorizados de las mejores marcas del
              mercado: Makita, DeWalt, Stanley, Bosch, Truper y ZOE. Nuestro
              equipo de expertos está siempre listo para asesorarte en tu
              próximo proyecto, ya sea una pequeña reparación en casa o una gran
              obra de construcción.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-262">
            <div className="bg-white p-5 rounded-lg border border-gray-100" data-id="element-263">
              <Award className="w-8 h-8 text-[#0056b3] mb-3" data-id="element-264" />
              <h3 className="font-semibold text-gray-900 mb-1" data-id="element-265">Calidad</h3>
              <p className="text-sm text-gray-500" data-id="element-266">
                Marcas reconocidas y garantizadas.
              </p>
            </div>
            <div className="bg-white p-5 rounded-lg border border-gray-100" data-id="element-267">
              <Truck className="w-8 h-8 text-[#0056b3] mb-3" data-id="element-268" />
              <h3 className="font-semibold text-gray-900 mb-1" data-id="element-269">Envíos</h3>
              <p className="text-sm text-gray-500" data-id="element-270">Entrega a toda Venezuela.</p>
            </div>
            <div className="bg-white p-5 rounded-lg border border-gray-100" data-id="element-271">
              <Users className="w-8 h-8 text-[#0056b3] mb-3" data-id="element-272" />
              <h3 className="font-semibold text-gray-900 mb-1" data-id="element-273">Equipo</h3>
              <p className="text-sm text-gray-500" data-id="element-274">
                Personal capacitado para asesorarte.
              </p>
            </div>
            <div className="bg-white p-5 rounded-lg border border-gray-100" data-id="element-275">
              <Clock className="w-8 h-8 text-[#0056b3] mb-3" data-id="element-276" />
              <h3 className="font-semibold text-gray-900 mb-1" data-id="element-277">
                Disponibilidad
              </h3>
              <p className="text-sm text-gray-500" data-id="element-278">
                Amplio horario y stock permanente.
              </p>
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="mt-16" data-id="element-279">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-280">
            ¿Por qué elegirnos?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-281">
            <div className="bg-white p-6 rounded-lg border border-gray-100 text-center" data-id="element-282">
              <div className="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-283">
                <Wrench className="w-7 h-7 text-[#0056b3]" data-id="element-284" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2" data-id="element-285">
                Herramientas Profesionales
              </h3>
              <p className="text-sm text-gray-500" data-id="element-286">
                Las mejores marcas del mercado para profesionales y aficionados.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-100 text-center" data-id="element-287">
              <div className="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-288">
                <Shield className="w-7 h-7 text-[#0056b3]" data-id="element-289" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2" data-id="element-290">
                Garantía en Productos
              </h3>
              <p className="text-sm text-gray-500" data-id="element-291">
                Todos nuestros productos cuentan con garantía del fabricante.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-100 text-center" data-id="element-292">
              <div className="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-293">
                <Users className="w-7 h-7 text-[#0056b3]" data-id="element-294" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2" data-id="element-295">
                Asesoría Personalizada
              </h3>
              <p className="text-sm text-gray-500" data-id="element-296">
                Te ayudamos a encontrar el producto ideal para tu proyecto.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}